
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
// interfaces
import { ExerciseVM } from "@/interfaces/ExerciseVM";

//const auth = namespace("auth");
// const globals = namespace("globals");
const globals = namespace("globals");


@Component({
  components: {
  }
})
export default class DeleteExerciseDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;

  @globals.Getter selectedExercise: any;
  @globals.Getter selectedBundle: any;
  busy = false;

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async onDelete() {
    this.busy = true;
    await rest.url("contentManager/deleteExercise")
      .query({ exerciseId: this.selectedExercise.id })
      .delete()
      .then((response) => {
        if (!response) return;
        this.$emit("deleted:deleteExerciseDlg");
        this.syncedShowDialog = false;
      })
      .finally(() => {
        this.busy = false;
      });
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }
}
